import { useState } from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Chip,
  Grid,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { IDatosTecnicosSnapshot } from '@/shared/interfaces/erp/tickets-soporte-clientes';

type DatosTecnicosCardProps = {
  datosTecnicos?: IDatosTecnicosSnapshot | null;
};

type CampoTecnicoProps = {
  label: string;
  value: string | null | undefined;
  isIp?: boolean;
  isStatus?: boolean;
};

function CampoTecnico({ label, value, isIp, isStatus }: CampoTecnicoProps) {
  return (
    <Grid item xs={12} sm={6} md={4}>
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
      {isIp && value ? (
        <Typography
          variant="body2"
          fontWeight={500}
          component="a"
          href={`http://${value}:80`}
          target="_blank"
          rel="noopener noreferrer"
          sx={{ display: 'block', color: 'primary.main', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
        >
          {value}
        </Typography>
      ) : isStatus && value ? (
        <Chip
          label={value}
          size="small"
          color={value === 'ACTIVO' ? 'success' : value === 'SUSPENDIDO' ? 'warning' : 'error'}
          sx={{ fontWeight: 600, mt: 0.5 }}
        />
      ) : (
        <Typography variant="body2" fontWeight={500}>
          {value || '-'}
        </Typography>
      )}
    </Grid>
  );
}

export default function DatosTecnicosCard({ datosTecnicos }: DatosTecnicosCardProps) {
  const [expanded, setExpanded] = useState(false);

  if (!datosTecnicos) {
    return null;
  }

  return (
    <Accordion expanded={expanded} onChange={() => setExpanded(!expanded)}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="h6" fontWeight="bold">
          Datos Tecnicos
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2}>
          <CampoTecnico label="Estado Servicio" value={datosTecnicos.estado_servicio} isStatus />
          <CampoTecnico label="Serie ONT" value={datosTecnicos.serie_ont} />
          <CampoTecnico label="Puerto PON" value={datosTecnicos.puerto_pon} />
          <CampoTecnico label="ONT ID" value={datosTecnicos.ont_id} />
          <CampoTecnico label="Line Profile" value={datosTecnicos.line_profile} />
          <CampoTecnico label="Service Profile" value={datosTecnicos.service_profile} />
          <CampoTecnico label="VLAN" value={datosTecnicos.vlan} />
          <CampoTecnico label="OLT Nombre" value={datosTecnicos.olt_nombre} />
          <CampoTecnico label="OLT IP" value={datosTecnicos.olt_ip} isIp />
          <CampoTecnico label="Vendor" value={datosTecnicos.vendor} />
          <CampoTecnico label="Modelo Equipo" value={datosTecnicos.modelo_equipo} />
          <CampoTecnico label="IP Cliente" value={datosTecnicos.ip_cliente} isIp />
          <CampoTecnico label="NAP Nombre" value={datosTecnicos.nap_nombre} />
          <CampoTecnico label="Potencia Senal" value={datosTecnicos.potencia_senal} />
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}
